export const SET_DATA = "CREATE-NEW-PROJECT/SET_DATA";
export const RESET = "CREATE-NEW-PROJECT/RESET";
